module.exports = __webpack_public_path__ + "img/드라군.37fdafaa.png";